<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div class="align-self-center">
                  <button
                    class="btn btn-light d-flex align-items-center text-dark p-1 border-0"
                    @click="$router.go(-1)"
                  >
                    <i class="nc-icon nc-stre-left font-weight-bold"></i>
                    <p class="m-0 ml-1">Voltar a lista</p>
                  </button>
                </div>
                <div>
                  <button
                    type="submit"
                    class="btn btn-success btn-fill"
                    @click="openModalConverter"
                    v-tooltip="'asdasdasdasd'"
                  >
                    Converter
                  </button>
                </div>
              </div>
              <div class="mt-3 mb-1">
                <label>Código:</label>
                <span>{{ ` ${this.lead.codigo}` }}</span>
              </div>
              <div class="mb-3">
                <label>Nome:</label>
                <span>{{ ` ${this.lead.nome}` }}</span>
              </div>
              <div class="d-flex align-items-center">
                <h4 class="mb-2 mt-2 mr-3">Linha do tempo</h4>
                <button
                  type="submit"
                  class="btn btn-success height-fit-content"
                  @click="openModalNovaMensagem"
                >
                  Nova mensagem
                </button>
                <button
                  type="submit"
                  class="ml-3 btn btn-info height-fit-content"
                  @click="mostrarDetalhes = !mostrarDetalhes"
                >
                  Detalhes da Proposta
                </button>
              </div>
            </template>
            <l-table
              class="table-hover table-striped"
              :columns="tabelaLinhaDoTempo.columns"
              :data="tabelaLinhaDoTempo.data"
            >
              <template slot-scope="{ row }">
                <td>{{ parseDate(row.data) }}</td>
                <td>
                  <b>{{ row.mensagem }}</b>
                </td>
              </template>
            </l-table>
          </card>
        </div>
      </div>
    </div>
    <Modal
      header="Nova mensagem"
      v-show="isVisibleModalNovaMensagem"
      :hasBody="true"
      @close="closeModalNovaMensagem"
    >
      <template v-slot:body>
        <textarea
          rows="1"
          class="form-control border-input"
          placeholder="Mensagem"
          v-model="novaMensagem"
        ></textarea>
      </template>
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-success"
          @click.prevent
          @click="enviarMensagem()"
        >
          Enviar
        </button>
      </template>
    </Modal>
    <Modal
      header="Deseja realmente converter o lead para cliente?"
      :hasBody="true"
      v-show="isVisibleModalConverter"
      @close="closeModalConverter"
    >
      <template v-slot:body>
        Esta ação é definitiva e não poderá ser desfeita.
      </template>
      <template v-slot:actions>
        <button
          type="button"
          class="btn btn-success"
          @click.prevent
          @click="converter()"
        >
          Converter
        </button>
      </template>
    </Modal>
    <div v-show="mostrarDetalhes" class="content">
      <div class="container-fluid">
        <card>
          <div class="row">
            <div class="col-12">
              <proposta-form :proposta="proposta"></proposta-form>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import LTable from 'src/components/Table.vue';
import PropostaForm from '../Forms/PropostaForm.vue';
import CrmService from 'src/services/crm';
import vPagination from 'vue-plain-pagination';
import VTooltip from 'v-tooltip';
import Modal from 'src/components/Modal';
import { MENSAGEM_ERRO_DEFAULT } from 'src/utils/constants';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['', ''];
export default {
  components: {
    LTable,
    PropostaForm,
    vPagination,
    VTooltip,
    Modal
  },
  data() {
    return {
      tabelaLinhaDoTempo: {
        columns: [...tableColumns],
        data: []
      },
      proposta: {},
      mostrarDetalhes: false,
      isModalVisible: false,
      anuncioAction: '',
      anuncio: {},
      isDeleteModalVisible: false,
      anuncioToDelete: {},
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      },
      codigo: '',
      lead: undefined,
      isVisibleModalNovaMensagem: false,
      novaMensagem: '',
      isVisibleModalConverter: false
    };
  },
  created() {
    this.codigo = this.$router.history.current.params.codigo;
    this.getLead();
  },
  methods: {
    getLead() {
      const loader = this.createLoading();

      CrmService.getByCodigo(this.codigo)
        .then(response => {
          var proposta;
          this.lead = response.data;
          proposta = _.get(response, 'data');
          this.proposta = { ...proposta };
          this.proposta.isModal = false;
          this.proposta.data = proposta.dataCriacao;
          this.proposta.cliente = {
            cidade: proposta.cidade,
            cidadeMediaMensal: proposta.cidadeMediaMensal,
            classe: proposta.classe,
            consumoMedio: proposta.consumoMedio,
            cpfOrCnpj: proposta.cpfOrCnpj,
            email: proposta.email,
            estado: proposta.estado,
            nome: proposta.nome,
            precoKWH: proposta.precoKWH,
            telefone: proposta.telefone,
            tensao: proposta.tensao,
            valorMediaMensalCidade: proposta.valorMediaMensalCidade
          };
          this.tabelaLinhaDoTempo.data = _.get(response, 'data.linhaDoTempo');

          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message = _.has(error, 'response.data.message')
            ? _.get(error, 'response.data.message')
            : MENSAGEM_ERRO_DEFAULT;

          this.notify({
            message,
            type: 'danger'
          });
          this.$router.replace('');
        });
    },
    createLoading() {
      return this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
    },
    notify({ type, message }) {
      let icon = '';
      switch (type) {
        case 'info':
          icon = 'fa fa-info';
          break;
        case 'success':
          icon = 'fa fa-check';
          break;
        case 'danger':
          icon = 'fa fa-exclamation-triangle';
      }
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: type
      });
    },
    parseDate(date) {
      const year = date.slice(0, 4);
      const month = date.slice(5, 7);
      const day = date.slice(8, 10);
      return `${day}/${month}/${year}`;
    },
    openModalNovaMensagem() {
      this.novaMensagem = '';
      this.isVisibleModalNovaMensagem = true;
    },
    closeModalNovaMensagem() {
      this.isVisibleModalNovaMensagem = false;
    },
    enviarMensagem() {
      this.isVisibleModalNovaMensagem = false;
      const loader = this.createLoading();

      CrmService.enviarMensagem({
        id: this.lead._id,
        mensagem: this.novaMensagem
      })
        .then(response => {
          loader.hide();
          this.notify({
            type: 'success',
            message: _.get(response, 'data.message')
          });
          this.getLead();
        })
        .catch(error => {
          loader.hide();
          const message = _.has(error, 'response.data.message')
            ? _.get(error, 'response.data.message')
            : MENSAGEM_ERRO_DEFAULT;

          this.notify({
            message,
            type: 'danger'
          });
        });
    },
    openModalConverter() {
      this.novaMensagem = '';
      this.isVisibleModalConverter = true;
    },
    closeModalConverter() {
      this.isVisibleModalConverter = false;
    },
    converter() {
      this.isVisibleModalConverter = false;
      const loader = this.createLoading();

      CrmService.converter(this.lead._id)
        .then(() => {
          loader.hide();
          this.notify({
            type: 'success',
            message: 'Convertido com sucesso'
          });
          this.$router.go(-1);
        })
        .catch(error => {
          loader.hide();
          const message = _.has(error, 'response.data.message')
            ? _.get(error, 'response.data.message')
            : MENSAGEM_ERRO_DEFAULT;

          this.notify({
            message,
            type: 'danger'
          });
        });
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.getLead();
      }
    }
  }
};
</script>
<style scoped>
.height-fit-content {
  height: fit-content;
}
</style>
